import { Fragment } from 'react'

import { Card } from '@wartek-id/card'
import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Separator } from '@wartek-id/separator'

import styles from 'app/KinerjaShared/components/CardKinerjaSteps/CardKinerjaSteps.module.css'
import useSKPPelaksanaanTrackEvent from 'app/KinerjaPage/hooks/useSKPPelaksanaanTrackEvent'
import {
  LINK_GUIDE,
  getStepsByPeriod,
} from 'app/KinerjaShared/components/CardKinerjaSteps/resource'

import type { Kinerja } from 'types/kinerja'

interface CardKinerjaStepsProps {
  period?: Kinerja['period']
}

const CardKinerjaSteps = ({ period = 1 }: CardKinerjaStepsProps) => {
  const steps = getStepsByPeriod(period)
  const { trackEvent } = useSKPPelaksanaanTrackEvent()

  return (
    <Card>
      <div className="p-6">
        <div className="flex justify-between items-center">
          <div className="flex flex-col gap-1">
            <Text variant="heading-md">Alur Pengelolaan Kinerja</Text>
            <Text color="subdued">
              Linimasa bersifat fleksibel dan dapat disesuaikan dengan satuan
              pendidikan atau didiskusikan dengan atasan.
            </Text>
          </div>

          <Button
            as="a"
            variant="ghost"
            size="lg"
            href={LINK_GUIDE}
            target="blank"
            onClick={() => {
              trackEvent({
                activity_type: 'penilaian_ks_home_click_selengkapnya',
                screen_name: 'ks_penilaian_home',
                event_trigger: 'ks_penilaian_home',
              })
            }}
          >
            Selengkapnya <Icon color="informational">chevron_right</Icon>
          </Button>
        </div>
      </div>

      <Separator />

      <div className="p-6">
        <div
          className="flex w-full overflow-x-auto"
          data-testid="section-steps"
        >
          <div className={styles.container}>
            {/* header */}
            {steps.map((step, index, { length }) => {
              const colSpan = step.description.length * 2 - 1

              return (
                <Fragment key={`header-${index}`}>
                  <div
                    style={{
                      gridColumn: `span ${colSpan} / span ${colSpan}`,
                    }}
                    className="bg-blue-10 py-1 rounded-md flex justify-center items-center"
                  >
                    <Text
                      color="informational"
                      className="!text-blue-60"
                      variant="body-bold"
                    >
                      {step.title}
                    </Text>
                  </div>
                  {index < length - 1 && <div className="w-6"></div>}
                </Fragment>
              )
            })}

            {/* content */}
            {steps
              .map((step) => step.description)
              .flat()
              .map((step, index, { length }) => (
                <Fragment key={`content-${index}`}>
                  <div className="h-full">
                    <Text>{step}</Text>
                  </div>

                  {index < length - 1 && (
                    <Icon color="informational">arrow_circle_right</Icon>
                  )}
                </Fragment>
              ))}
          </div>
        </div>
      </div>
    </Card>
  )
}

export default CardKinerjaSteps
